function Card (props) {
    return (
        <a href={props.link}>
        <div className="cardContainer">
            <div className="cardContent">
                <img className="cardImg" src={props.cardImg}/>
                <div className="cardGradient"/>
                <div className="cardTitle">
                    <h3 className="cardText">{props.title}</h3>
                    <img className='cardIcon' src='/images/icons/arrow-card.svg'/>
                </div>
            </div>
        </div>
        </a>
    )
}
export default Card;